var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.filterType !== 9
        ? _c(
            "el-input-number",
            _vm._g(
              _vm._b(
                {
                  ref: "numberInput",
                  attrs: {
                    value: _vm.inputcount,
                    controls: false,
                    "controls-position": "right",
                    placeholder: _vm.placeholderspan,
                    size: "mini",
                  },
                  on: { input: _vm.handle },
                },
                "el-input-number",
                _vm.$attrs,
                false
              ),
              _vm.$listeners
            )
          )
        : _vm._e(),
      _vm.filterType === 9
        ? _c(
            "div",
            [
              _c(
                "el-input-number",
                _vm._g(
                  _vm._b(
                    {
                      ref: "numberInput",
                      attrs: {
                        "controls-position": "right",
                        placeholder: _vm.placeholderspan,
                        size: "mini",
                        controls: false,
                      },
                      on: { input: _vm.handlecount },
                      model: {
                        value: _vm.inputcount1,
                        callback: function ($$v) {
                          _vm.inputcount1 = $$v
                        },
                        expression: "inputcount1",
                      },
                    },
                    "el-input-number",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              ),
              _vm._v(" - 到 - "),
              _c(
                "el-input-number",
                _vm._g(
                  _vm._b(
                    {
                      ref: "numberInput",
                      attrs: {
                        "controls-position": "right",
                        placeholder: _vm.placeholderspan,
                        size: "mini",
                        controls: false,
                      },
                      on: { input: _vm.handlecount },
                      model: {
                        value: _vm.inputcount2,
                        callback: function ($$v) {
                          _vm.inputcount2 = $$v
                        },
                        expression: "inputcount2",
                      },
                    },
                    "el-input-number",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }